// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.shared.person.PersonGeneralHistoryResponse */
/* istanbul ignore next */
@GandalfModel
export class PersonGeneralHistoryResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	drugAllergyComment!: string | null;

	@GandalfProperty({ designType: String })
	insurance!: string | null;

	@GandalfProperty({ designType: String })
	medications!: string | null;

	@GandalfProperty({ designType: Boolean })
	noKnownDrugAllergies!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	noLatexSensitivity!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	noOtherKnownAllergies!: boolean | null;

	@GandalfProperty({ designType: String })
	otherAllergyComment!: string | null;

	@GandalfProperty({ designType: Number })
	personId!: number | null;

}
